<div class="left-menu">


  <nav id="sidebar" class="positionF left-menu scroll-sideNav">
    <div class="d-flex text-center content-center mt-2">
      <button *ngIf="profile_pic == ''" id="arevea_sideNav" class="profile-pic">
        {{displayName |uppercase}}
      </button>
      <button *ngIf="profile_pic != ''"
        [ngStyle]="{'background-image':' url(' + profile_pic + ')','background-size':'contain','background-position':'center','background-repeat':'no-repeat'}"
        id="arevea_sideNav" class="profile-pic1">
      </button>
    </div>
    <div class="text-center mt-10">
      <span *ngIf="profileName?.length <= 16" class="profileName">{{profileName}}
      </span>
      <span *ngIf="profileName?.length > 16" matTooltipPosition="above" matTooltip="{{profileName}}"
        class="profileName">
        {{profileName | slice: 0:16}}
        {{profileName.length > 16 ? "..." : ""}}
      </span>
    </div>
    <div class="row mt-1">
      <div class="col-6 text-center" *ngIf="isCryptoWallet==1">
        <p class="cryptoName mb-1">
          Crypto Wallet
        </p>
        <button mat-flat-button class="cryptoButton d-flex justify-content-center" [ngClass]="{'cursor-default': walletID}">
          <span *ngIf="walletID== undefined || walletID == '' || walletID == null" (click)="connectToWallet()">Connect</span>
          <span *ngIf="walletID" matTooltip="{{available_balance}}"><img src="{{cryptoSymbol}}" width="16" class="mb-1 mr-1">{{ crypto_balance }}</span>
        </button>
      </div>

      <div class="col-6 text-center" *ngIf="isCryptoWallet==1">
        <p class="cryptoName mb-1">
          Cash Wallet
        </p>
        <button mat-flat-button class="cryptoButton custom-red-button" routerLinkActive="router-link-active"
          [routerLink]="'/' + channelName + '/user-dashboard/cash-wallet'">
          <span *ngIf="walletInfo?.amount != null "> {{walletInfo?.amount |currency:walletInfo?.currency}}</span>
          <span *ngIf="walletInfo?.amount == null ">{{0.00
            | currency:getCurrency}}</span>

        </button>
      </div>

      <div class="col-12 text-center" *ngIf="isCryptoWallet!=1">
        <p class="cryptoName mb-1">
          Cash Wallet
        </p>
        <button mat-flat-button class="cryptoButton custom-red-button" routerLinkActive="router-link-active"
          [routerLink]="'/' + channelName + '/user-dashboard/cash-wallet'">
          <span *ngIf="walletInfo?.amount != null "> {{walletInfo?.amount |currency:walletInfo?.currency}}</span>
          <span *ngIf="walletInfo?.amount == null ">{{0.00
            | currency:getCurrency}}</span>

        </button>
      </div>
    </div>
    <ul class="list-unstyled components pr-0 pt-10">
      <li *ngFor="let list of menuList">
        <div>
          <div *ngIf="list?.sub_menu?.length == 0 && (!list.adminOnly || admin)" class="menu-padding pointer"
            [ngClass]="{'active-menu': list.activeMenu,'mb-5': list.activeMenu}" (click)="goToMenu(list.link, list)">
            <div fxLayout="row">
              <i class="{{ list.icon }}" aria-hidden="true" *ngIf="!list.hide "></i>
              <span class="menu-name" [ngClass]="{'c-p':list.activeMenu}" *ngIf="!list.hide ">{{ list.name }}</span>
            </div>
          </div>
        </div>
        <span *ngIf="list?.sub_menu?.length > 0">
          <div [ngClass]="{'active-menu': list.activeMenuList,'mb-10': list.activeMenuList}"
            class="pointer" (click)="toggleMenuList(list)">
            <i class="{{ list.icon }} mr-0 ml-20" aria-hidden="true"></i>
            <span class="menu-namep pointer">{{ list.name }}</span>
            <i class="fa fa-angle-right ml-32" *ngIf="!list.activeMenuList"></i>
            <i class="fa fa-angle-down ml-32" *ngIf="list.activeMenuList"></i>
          </div>

          <div *ngIf="list.activeMenuList">
            <div class="ml-45 menu-name pointer" *ngFor="let menu of list.sub_menu"
              (click)="navigateSubmenu(menu.link)">
              <div [ngClass]="{ 'active-type': menu.subMenuActive}"> {{menu.menu_name}}</div>
            </div>
          </div>
        </span>

        <!-- <span class="menu-name" *ngIf="list.sub_menu.length > 0">
          <mat-expansion-panel [expanded]="list.activeMenuList" (opened)="list.activeMenuList"
            (closed)="!list.activeMenuList" [ngClass]="{
            'active-menu': list.activeMenuList,
            'mb-10': list.activeMenuList
          }" (click)="goToMenu(list.link, list)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="menu-padding pointer">
                  <i class="{{ list.icon }}" aria-hidden="true"></i>
                  <span class="sub-menu-name">{{ list.name }}</span>
                  <i class="fa fa-angle-right ml-32" *ngIf="!list.activeMenuList"></i>
                  <i class="fa fa-angle-down ml-32" *ngIf="list.activeMenuList"></i>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div fxLayout="column">
              <div class=" menu-name ml-45 pointer" *ngFor="let menu of list.sub_menu"
                (click)="navigateSubmenu(menu.link)" [ngClass]="{
                'active-type': menu.subMenuActive}">
                {{menu.menu_name}}
              </div>
            </div>
          </mat-expansion-panel>
        </span> -->
      </li>
      <!-- use for partner login dashboard-->
      <!-- <li *ngFor="let list of dashboardList">
                    <div class="menu-padding" [ngClass]="{}"> 
                            <div fxLayout="row">
                                <i class="{{list.icon}}" aria-hidden="true"></i>
                                <span class="menu-name">{{list.name}}</span>
                            </div> 
                    </div>
                </li> -->
    </ul>
    <div class="text-center">
      <!-- <button mat-flat-button class="flat-primary-button mt-10 ">
        yes
    </button> -->
      <button mat-flat-button class="logoutButton custom-red-button" (click)="signout()">Logout</button>
    </div>
  </nav>

</div>